import axios from "axios"
import { appConstants } from '../../_constants';
export const request = (path, data, method) => {
      return axios({
        method: method,
        url: `${appConstants.WEB_SERVICE_URL}/${path}`,
          headers: {
            'crossDomain': true,           
            "authorization":"Key@123"           
          },
        data:data
      })
}


export const requestss = (path, data, method) => {
      return axios({
        method: method,
        url:path,
          headers: {
            'crossDomain': true ,
            'content-type':"Json",
            "authorization":"Key@123"           
          }
      })
}
export const postRequestWithoutSession = (path, data) => request(path, data, "POST");
export const getRequestWithoutSession = (path, data) => requestss(path, data, "GET");



// WEBPACK FOOTER //
// ./src/api/Admin/helper-without-session.js